import React from "react";
import Nav from "./Nav";
import MobileHeader from "./Mobile-Header";
import Logo from "../common/Logo";
import Cta from "../common/Cta";
import { CONFIG } from "../const/config";

const Header = () => {
  return (
    <div className="nav-container">
      {/* <MobileHeader /> */}

      <nav
        id="avl-webdev-menu"
        className="bar bar-2 bar--transparent bar--absolute"
        data-scroll-class="90vh:pos-fixed"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-4  text-center text-left-sm order-lg-2">
              <div className="bar__module">
                <Logo />
              </div>
            </div>
            <div className="col-lg-4 order-lg-1 hidden-sm px-0">
              <div className="bar__module">
                <Nav />
              </div>
            </div>
            <div
              className="col-lg-4 text-right text-center-xs text-center-sm hidden-xs order-lg-3 px-0"
              id="nav-ctas"
            >
              <div className="bar__module">
                {CONFIG.blog ? (
                  <Cta
                    label="Read Blog"
                    link={CONFIG.siteRoot + CONFIG.sitePaths.blog}
                    classes="type--bold btn--sm"
                    type="primary"
                  />
                ) : null}
                <Cta
                  type="outline-white"
                  label="&nbsp; Get in Touch"
                  link="https://www.linkedin.com/in/anthony-lombardo-45b48a15/"
                  classes="type--bold btn--sm"
                  newWindow={true}
                >
                  <i className="socicon socicon-linkedin icon icon--xs"></i>
                </Cta>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
